import { render, staticRenderFns } from "./ageControl.vue?vue&type=template&id=4ad09b9c&scoped=true&"
import script from "./ageControl.vue?vue&type=script&lang=js&"
export * from "./ageControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad09b9c",
  null
  
)

export default component.exports